export const getMarkupType = state => state.settings.markupType
export const getCurrency = state => state.settings.currency



// WEBPACK FOOTER //
// ./src/selectors/settings.js